import { BasketState } from "../../types/rtk/basket/basket";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: BasketState = {
  offer_id: null,
  options: null,
  giftcard: null,
  promo: null,
  giftcard_ratio: null,
  promocode_ratio: null
};

const BasketSlice = createSlice({
  name: "basket",
  initialState: initialState,
  reducers: {
    setBasket: (state, action: PayloadAction<BasketState>) => {
      state.offer_id = action.payload.offer_id;
      state.options = action.payload.options;
      state.giftcard = action.payload.giftcard;
      state.promo = action.payload.promo;
      state.giftcard_ratio = action.payload.giftcard_ratio;
      state.promocode_ratio = action.payload.promocode_ratio;
    },
    resetBasket: () => initialState,
  },
});

export const { setBasket, resetBasket } = BasketSlice.actions;
const BasketReducer = BasketSlice.reducer;
export default BasketReducer;
